export const GET_ALL_CASES_REQUEST = "GET_ALL_CASES_REQUEST";
export const GET_ALL_CASES_SUCCESS = "GET_ALL_CASES_SUCCESS";
export const GET_ALL_CASES_FAIL = "GET_ALL_CASES_FAIL";
export const RESET_ALL_CASES = "RESET_ALL_CASES";

export const GET_UNPAGINATED_CASES_REQUEST = "GET_UNPAGINATED_CASES_REQUEST";
export const GET_UNPAGINATED_CASES_SUCCESS = "GET_UNPAGINATED_CASES_SUCCESS";
export const GET_UNPAGINATED_CASES_FAIL = "GET_UNPAGINATED_CASES_FAIL";
export const RESET_UNPAGINATED_CASES = "RESET_UNPAGINATED_CASES";

export const GET_A_CASE_BY_CID_REQUEST = "GET_A_CASE_BY_CID_REQUEST";
export const GET_A_CASE_BY_CID_SUCCESS = "GET_A_CASE_BY_CID_SUCCESS";
export const GET_A_CASE_BY_CID_FAIL = "GET_A_CASE_BY_CID_FAIL";
export const RESET_A_CASE_BY_CID = "RESET_A_CASE_BY_CID";

export const GET_CASE_BY_AGENT_REQUEST = "GET_CASE_BY_AGENT_REQUEST";
export const GET_CASE_BY_AGENT_SUCCESS = "GET_CASE_BY_AGENT_SUCCESS";
export const GET_CASE_BY_AGENT_FAIL = "GET_CASE_BY_AGENT_FAIL";

export const GET_CLIENT_PAINLOGS_REQUEST = "GET_CLIENT_PAINLOGS_REQUEST";
export const GET_CLIENT_PAINLOGS_SUCCESS = "GET_CLIENT_PAINLOGS_SUCCESS";
export const GET_CLIENT_PAINLOGS_FAIL = "GET_CLIENT_PAINLOGS_FAIL";

export const ADD_NEW_CASE_REQUEST = "ADD_NEW_CASE_REQUEST";
export const ADD_NEW_CASE_SUCCESS = "ADD_NEW_CASE_SUCCESS";
export const ADD_NEW_CASE_FAIL = "ADD_NEW_CASE_FAIL";

export const UPDATE_CASE_REQUEST = "UPDATE_CASE_REQUEST";
export const UPDATE_CASE_SUCCESS = "UPDATE_CASE_SUCCESS";
export const UPDATE_CASE_FAIL = "UPDATE_CASE_FAIL";
export const UPDATE_CASE_RESET = "UPDATE_CASE_RESET";

export const DELETE_CASE_REQUEST = "DELETE_CASE_REQUEST";
export const DELETE_CASE_SUCCESS = "DELETE_CASE_SUCCESS";
export const DELETE_CASE_FAIL = "DELETE_CASE_FAIL";
export const RESET_DELETE_CASE = "RESET_DELETE_CASE";

export const GET_CASE_CLIENT_DOCUMENTS_REQUEST =
  "GET_CASE_CLIENT_DOCUMENTS_REQUEST";
export const GET_CASE_CLIENT_DOCUMENTS_SUCCESS =
  "GET_CASE_CLIENT_DOCUMENTS_SUCCESS";
export const GET_CASE_CLIENT_DOCUMENTS_FAIL = "GET_CASE_CLIENT_DOCUMENTS_FAIL";
export const RESET_CASE_CLIENTS_DOCUMENTS = "RESET_CASE_CLIENTS_DOCUMENTS";

// DASHBOARD ANALYTICS
export const GET_DASHBOARD_ANALYTICS_REQUEST =
  "GET_DASHBOARD_ANALYTICS_REQUEST";
export const GET_DASHBOARD_ANALYTICS_SUCCESS =
  "GET_DASHBOARD_ANALYTICS_SUCCESS";
export const GET_DASHBOARD_ANALYTICS_FAIL = "GET_DASHBOARD_ANALYTICS_FAIL";

export const GET_HIGHRISK_CASES_REQUEST = "GET_HIGHRISK_CASES_REQUEST";
export const GET_HIGHRISK_CASES_SUCCESS = "GET_HIGHRISK_CASES_SUCCESS";
export const GET_HIGHRISK_CASES_FAIL = "GET_HIGHRISK_CASES_FAIL";

export const GET_UNREAD_CHAT_MESSAGES_REQUEST =
  "GET_UNREAD_CHAT_MESSAGES_REQUEST";
export const GET_UNREAD_CHAT_MESSAGES_SUCCESS =
  "GET_UNREAD_CHAT_MESSAGES_SUCCESS";
export const GET_UNREAD_CHAT_MESSAGES_FAIL = "GET_UNREAD_CHAT_MESSAGES_FAIL";

export const GET_PIE_CHART_STATS_REQUEST = "GET_PIE_CHART_STATS_REQUEST";
export const GET_PIE_CHART_STATS_SUCCESS = "GET_PIE_CHART_STATS_SUCCESS";
export const GET_PIE_CHART_STATS_FAIL = "GET_PIE_CHART_STATS_FAIL";
export const RESET_PIE_CHART_STATS = "RESET_PIE_CHART_STATS";

export const ADD_QUESTION_TO_CASE_REQUEST = "ADD_QUESTION_TO_CASE_REQUEST";
export const ADD_QUESTION_TO_CASE_SUCCESS = "ADD_QUESTION_TO_CASE_SUCCESS";
export const ADD_QUESTION_TO_CASE_FAIL = "ADD_QUESTION_TO_CASE_FAIL";
export const RESET_ADD_QUESTION_TO_CASE = "RESET_ADD_QUESTION_TO_CASE";

export const ADD_NOTE_TO_CASE_REQUEST = "ADD_NOTE_TO_CASE_REQUEST";
export const ADD_NOTE_TO_CASE_SUCCESS = "ADD_NOTE_TO_CASE_SUCCESS";
export const ADD_NOTE_TO_CASE_FAIL = "ADD_NOTE_TO_CASE_FAIL";
export const RESET_ADD_NOTE_TO_CASE = "RESET_ADD_NOTE_TO_CASE";
